// PLAN.md §2.2 #6 — "Exit and profit · $X.XX" button visible only when local
// player is in a cell. Clicking banks the position.

import { AnimateNumber } from 'motion-plus/react'
import { Button } from '../ported/index.js'
import { useStore } from '../../store.js'
import { sendMove } from '../../socket.js'

export function ExitAndProfitBar() {
  const self = useStore((s) => s.self)
  if (!self) return null
  const inCell = self.active_cell !== 'spectator' && self.active_status !== 'liquidated'
  if (!inCell) return null

  return (
    <div className="px-2">
      <Button
        variant="primary"
        size="lg"
        loading={self.optimistic_busy && self.optimistic_target === 'spectator'}
        onClick={() => sendMove('spectator')}
        className="w-full"
      >
        <span className="inline-flex gap-1 items-baseline">
          <span>Exit and profit</span>
          <span className="text-grey">·</span>
          <span className="tabular-nums">
            <AnimateNumber
              prefix="$"
              locales="en-US"
              format={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
            >
              {self.active_stake}
            </AnimateNumber>
          </span>
        </span>
      </Button>
    </div>
  )
}
